import { render } from "./TrialEndClock.vue?vue&type=template&id=22a152aa&scoped=true"
import script from "./TrialEndClock.vue?vue&type=script&lang=js"
export * from "./TrialEndClock.vue?vue&type=script&lang=js"

import "./TrialEndClock.vue?vue&type=style&index=0&id=22a152aa&scoped=true&lang=scss"
import "./TrialEndClock.vue?vue&type=style&index=1&id=22a152aa&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22a152aa"]])

export default __exports__